import { Header } from 'components/Header'
import React, { FC, useEffect, PropsWithChildren } from 'react'
import { Col, Container, Row, Button } from 'react-bootstrap'
import { UrlParams, TemplateIdUrlParam, TemplateSubDirectoryParam, TemplateUrlParam, ProjectRolesAndPermissionParam } from 'types'
import { useDataLoader } from 'hooks/useDataLoader'
import { navigate, useQueryParams } from 'hookrouter'
import { deleteDirectory, getPermissionsList } from 'state/async_actions'
import { useAppContext } from 'state/context'
import { fetchTemplateDirectories } from 'hooks/useDataLoader'
import { TemplateDeletionWarningModal } from 'components/TemplateDeletionWarningModal'
import { useProjectsForCompany } from 'hooks/useProjectsForCompany'
import { useCompany } from 'hooks/useCompany'
import { userRoles } from 'types'
import { BackButton } from 'components/BackButton/BackButton'
import { AddCompanyManagerDropdown } from 'components/AddCompanyManagerDropdown'
import { usePermissions } from 'hooks/useCompanyManagers'
import { defaultTemplateId } from 'utils/constants'

export const AuthorizedView: FC<PropsWithChildren<Partial<UrlParams & TemplateIdUrlParam & TemplateSubDirectoryParam & TemplateUrlParam & ProjectRolesAndPermissionParam>>> = ({
  companyId,
  projectId,
  children,
  templateDocumentId,
  templateSubDocumentId,
  isTemplate,
  projectUserType,
  projectPermissionType
}) => {
  const projectList = useProjectsForCompany(companyId)
  const company = useCompany(companyId)

  const [, dispatch] = useAppContext()
  const params = useQueryParams();

  let url;
  if (projectUserType) {
    if (projectUserType == 2)
      url = 'project_manager_roles'
    else if (projectUserType == 3)
      url = 'super_foreman_roles'
    else if (projectUserType == 4)
      url = 'sub_contractor_roles'
    else if (projectUserType == 5)
      url = 'project_coordinator_roles'
  }
  useDataLoader(companyId, projectId, isTemplate ? undefined : templateDocumentId, isTemplate ? undefined : templateSubDocumentId, isTemplate, url)
  const [deleteTemplateDirectory, setDeleteDirectory] = React.useState<
    (() => () => void) | undefined
  >()

  const companyPath = (companyId: number | undefined) => {
    navigate(`/company/${companyId}`)
  }
  const projectPath = (companyId: any, projectId: any) => {
    navigate(`/company/${companyId}/project/${projectId}`)
  }
  const directoryPath = (companyId: any, projectId: any, templateDocumentId: any) => {
    navigate(`/company/${companyId}/project/${projectId}/directory/${templateDocumentId}`)
  }
  const subDirectoryPath = (companyId: number | undefined, projectId: number | undefined, templateDocumentId: number | undefined, templateSubDocumentId: number | undefined) => {
    navigate(`/company/${companyId}/project/${projectId}/directory/${templateDocumentId}/subFolder/${templateSubDocumentId}`)
  }

  const permissionPath = (companyId: number | undefined, projectId: number | undefined, projectUserType: number | undefined) => {
    navigate(`/company/${companyId}/project/${projectId}/projectPermissionList/${projectUserType}`)
  }
  // const projectPath = (companyId:number, projectId:number, templateDocumentId: number, templateSubDocumentId: number)=> {
  //   navigate(`/company/${companyId}/project/${projectId}/directory/${templateDocumentId}/subFolder/${templateSubDocumentId}`)
  // }
  const warningText = `You are about to permanently delete a directory. All
  documents derived from this directory will also be destroyed. Do you want to continue?`

  const resetDirectoryDeletionWarning = () => {
    setDeleteDirectory(undefined)
  }
  const warnAndDeleteDirectory = () => {
    setDeleteDirectory(() => () => {
      if (templateSubDocumentId) {
        deleteDirectory(dispatch, templateSubDocumentId);
        fetchTemplateDirectories(dispatch, projectId, templateDocumentId)
        directoryPath(companyId, projectId, templateDocumentId);
      } else if (templateDocumentId) {
        deleteDirectory(dispatch, templateDocumentId);
        fetchTemplateDirectories(dispatch, projectId)
        projectPath(companyId, projectId);
      }
    });
  }

  const getProjectName = (companyId: any) => {
    return projectList.find((company: any) => company.id === projectId)?.name
  }
  let userRoleType: any = 1;
  const selectedProject: any = projectList.find((company: any) => company.id === projectId) || {};

  if (selectedProject.isCompanyManager)
    userRoleType = 1;
  else if (selectedProject.isProjectManager)
    userRoleType = 2;
  else if (selectedProject.isProjectCoordinator)
    userRoleType = 5;

  useEffect(() => {
    if (companyId && userRoleType)
      getPermissionsList(dispatch, companyId, userRoleType)
  }, [dispatch, companyId, userRoleType])

  const permissionsList: any = usePermissions(userRoleType);

  const getDirectoryName = (type: string, id: number | undefined) => {
    let template = { id: 1, name: '' };
    if (type === 'parentDirectory')
      template = JSON.parse(localStorage.getItem('parentDirectory') || '')
    else
      template = JSON.parse(localStorage.getItem('subDirectory') || '')
    return template.id === id ? template?.name : ''
  }

  return (
    <>
      {deleteTemplateDirectory && (
        <TemplateDeletionWarningModal
          confirmAction={deleteTemplateDirectory}
          updateParentState={resetDirectoryDeletionWarning}
          text={warningText}
        />
      )}
      <div className="content">
        <Header companyId={companyId || 0} projectId={projectId || 0} />

        {!projectUserType && !projectPermissionType && projectId &&
          <>
            <div className="row">
              <div className="col-10 custom-button" style={{ fontSize: 'larger', fontWeight: 'bold', paddingLeft: '3%', paddingTop: '1%' }}>
                {companyId && (<Button style={{ borderColor: 'transparent', backgroundColor: 'transparent', color: '#00349a !important' }} onClick={() => companyPath(companyId)}> {company?.name}</Button>)}
                {projectId && (<><span>/ &nbsp;</span><Button style={{ borderColor: 'transparent', backgroundColor: 'transparent' }} onClick={() => projectPath(companyId, projectId)}> {getProjectName(projectId)}</Button></>)}
                {templateDocumentId && (<><span>/ &nbsp;</span><Button style={{ borderColor: 'transparent', backgroundColor: 'transparent' }} onClick={() => directoryPath(companyId, projectId, templateDocumentId)}> {getDirectoryName('parentDirectory', templateDocumentId)}</Button></>)}
                {templateSubDocumentId && (<><span>/ &nbsp;</span><Button style={{ borderColor: 'transparent', backgroundColor: 'transparent' }} onClick={() => subDirectoryPath(companyId, projectId, templateDocumentId, templateSubDocumentId)}> {getDirectoryName('subDirectory', templateSubDocumentId)}</Button></>)}
              </div>
              <div className="col-2" style={{ fontSize: 'larger', fontWeight: 'bold', paddingLeft: '3%', paddingTop: '1%', justifyContent: 'flex-end' }}>
                {((templateDocumentId || templateSubDocumentId) && permissionsList?.template_document?.can_delete_folder && selectedProject?.status == 'active') && <Button className="disabled-button" onClick={warnAndDeleteDirectory}>Delete Folder</Button>}
              </div>
            </div>
            <hr />
          </>
        }
        {projectUserType &&
          <>
            <div className="row">
              <div className={(selectedProject.isCompanyManager || selectedProject.isAdmin) ? 'col-7' : 'col-7'} style={{ fontSize: 'larger', fontWeight: 'bold', paddingLeft: '3%', paddingTop: '22px' }}>
                <span>{userRoles.find((role) => role.id === projectUserType)?.name}</span>
              </div>
              <div className={(selectedProject.isCompanyManager || selectedProject.isAdmin) ? 'col-5' : 'col-5'} style={{ fontSize: 'larger', fontWeight: 'bold', paddingLeft: '3%', paddingTop: '1%', display: 'inline-flex', justifyContent: 'flex-end' }}>
                {((selectedProject.isProjectCoordinator && ((projectUserType == 2 && permissionsList?.invite?.invite_project_manager) || (projectUserType == 3 && permissionsList?.invite?.invite_other_roles) || (projectUserType == 4 && permissionsList?.invite?.invite_other_roles) || (projectUserType == 5 && permissionsList?.invite?.invite_other_roles))) || (selectedProject.isCompanyManager && ((projectUserType == 1 && permissionsList?.invite?.invite_company_manager) || (projectUserType == 2 && permissionsList?.invite?.invite_project_manager) || (projectUserType == 3 && permissionsList?.invite?.invite_other_roles) || (projectUserType == 4 && permissionsList?.invite?.invite_other_roles) || (projectUserType == 5 && permissionsList?.invite?.invite_other_roles))))
                  && <AddCompanyManagerDropdown companyId={companyId} projectId={projectId} templateDocumentId={params?.[0]?.templateDocumentId || defaultTemplateId} excludedCompanyManagers={[]} isOtherRole={projectUserType == 1 ? false : true} roleType={userRoles.find((role) => role.id === projectUserType)?.name} url={userRoles.find((role) => role.id === projectUserType)?.url} />}
                {/* <Button className="btn-icon-plus" onClick={warnAndDeleteDirectory}>Add {userRoles.find((role)=> role.id === projectUserType)?.name} </Button> */}
                {/* {(selectedProject.isCompanyManager || selectedProject.isAdmin) && projectUserType!=1 && <Button onClick={()=>{ permissionPath(companyId, projectId, projectUserType)}}>Manage Permissions </Button>} */}
                {(selectedProject.isCompanyManager || selectedProject.isAdmin) && projectUserType != 1 && projectUserType != 4 && <Button onClick={() => { permissionPath(companyId, projectId, projectUserType) }}>Manage Permissions </Button>}
                <BackButton />
              </div>
            </div>
            <hr />
          </>
        }
        {projectPermissionType &&
          <>
            <div className="row">
              <div className="col-10" style={{ fontSize: 'larger', fontWeight: 'bold', paddingLeft: '3%', paddingTop: '22px' }}>
                <span> Manage Permissions</span>
              </div>
              <div className="col-2" style={{ fontSize: 'larger', fontWeight: 'bold', paddingLeft: '3%', paddingTop: '10px', display: 'inline-flex', justifyContent: 'flex-end' }}>
                <BackButton />
              </div>
            </div>
            <hr />
          </>
        }
        <Container fluid>
          <Row>
            <Col>{children}</Col>
          </Row>
        </Container>
      </div>
    </>
  )
}
